export default "__VITE_ASSET__Dqe5dvlL__"